export const CREATE_STUDY = 'CREATE_STUDY'
export const UPDATE_STUDY = 'UPDATE_STUDY'
export const DELETE_STUDY = 'DELETE_STUDY'
